module.exports = __webpack_public_path__ + "images/patterns/light/Scale.57ddd842d4b2029a0d05.svg";